/* eslint-disable no-trailing-spaces */
'use strict';
var focusHelper = require('base/components/focus');
var pricingConstants = require('../../../../scripts/constants/PricingConstants');
var productConstants = require('../../../../scripts/constants/ProductConstants');

/**
 * Finds the needle in the haystack
 * Alternative to indexOf, since we don't support the native ES6 .includes method
 * 
 * @param {object} haystack 
 * @param {string} needle 
 * @returns {boolean}
 */
function includes(haystack, needle) {
    return haystack.indexOf(needle) !== -1;
}

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el)
            .closest('.modal-content')
            .find('.product-quickview')
            .data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').text();
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    return $el
        ? $($el)
            .closest('.product-detail')
            .find('[data-product-field="quantity"]')
        : $('[data-product-field="quantity"]');
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find(
            '[data-attr="' +
            attr.id +
            '"] [data-attr-value="' +
            attrValue.value +
            '"]'
        );
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue
                .siblings('.selected-assistive-text')
                .text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');

        $attrValue.addClass(
            attrValue.selectable ? 'selectable' : 'unselectable'
        );
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {boolean} isVariationAttrbutesButtons - boolean for whether the variation attributes are displayed as buttons instead of dropdown
 */
function processNonSwatchValues(
    attr,
    $productContainer,
    isVariationAttrbutesButtons
) {
    var $attr = '[data-attr="' + attr.id + '"]';
    if (isVariationAttrbutesButtons !== true) {
        var $defaultOption = $productContainer.find(
            $attr + ' .select-' + attr.id + ' option:first'
        );
        $defaultOption.attr('value', attr.resetUrl);
    }

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find(
            $attr + ' [data-attr-value="' + attrValue.value + '"]'
        );
        $attrValue.attr('value', attrValue.url).removeAttr('disabled');

        // Added logic to prevent donationFrequencies from being disabled when changing donation amount
        if (!attrValue.selectable && attr.attributeId != 'donationFrequency') {
            $attrValue.attr('disabled', true);
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 * @param {boolean} isVariationAttrbutesButtons - boolean for whether the variation attributes are displayed as buttons instead of dropdown
 */
function updateAttrs(
    attrs,
    $productContainer,
    msgs,
    isVariationAttrbutesButtons
) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(
                attr,
                $productContainer,
                isVariationAttrbutesButtons
            );
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue =
            '<li><div>' +
            response.resources.info_selectforstock +
            '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources,
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html +=
                    '<div class="attribute-values">' +
                    attribute.label +
                    ': ' +
                    attribute.value +
                    '</div>';
            });
        }
    });

    return html;
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
}

/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function createCarousel(imgs, $productContainer) {
    var largeImages = imgs.large;
    var smallImages = imgs.small;

    var carousel = $productContainer.find('.carousel');

    $(carousel).carousel('dispose');

    var carouselId = $(carousel).attr('id');

    // Generate new Carousel.
    $(carousel)
        .empty()
        .append(
            '<ol class="carousel-indicators"></ol><div class="carousel-inner" role="listbox"><button id="pdpCarouselClose" class="imageCarousel__close"><i class="uit uit-times"></i></button></div><a class="carousel-control-prev" href="#' +
            carouselId + // eslint-disable-line
            '" role="button" data-slide="prev"><i class="uit uit-angle-left-b"></i><span class="sr-only">' + // eslint-disable-line
            $(carousel).data('prev') + // eslint-disable-line
            '</span></a><a class="carousel-control-next" href="#' + // eslint-disable-line
            carouselId + // eslint-disable-line
            '" role="button" data-slide="next"><i class="uit uit-angle-right-b"></i><span class="sr-only">' + // eslint-disable-line
            $(carousel).data('next') + // eslint-disable-line
            '</span></a> <div class="zoom-background"></div>' // eslint-disable-line
        );

    // Fill carousel inner with images.
    for (var i = 0; i < largeImages.length; i++) {
        $(
            '<div class="carousel-item"><img src="' + // eslint-disable-line
            largeImages[i].url + // eslint-disable-line
            '" class="d-block img-fluid" alt="' + // eslint-disable-line
            largeImages[i].alt + // eslint-disable-line
            ' image number ' + // eslint-disable-line
            parseInt(largeImages[i].index, 10) + // eslint-disable-line
            '" title="' + // eslint-disable-line
            largeImages[i].title + // eslint-disable-line
            '" itemprop="image" /></div>' // eslint-disable-line
        ).appendTo($(carousel).find('.carousel-inner'));

        $(
            '<li data-target="#' +
            carouselId + // eslint-disable-line
            '" data-slide-to="' + // eslint-disable-line
            i + // eslint-disable-line
            '" class=""></li>' // eslint-disable-line
        ).appendTo($(carousel).find('.carousel-indicators'));
    }

    $($(carousel).find('.carousel-item')).first().addClass('active');
    $($(carousel).find('.carousel-indicators > li')).first().addClass('active');

    if (largeImages.length === 1) {
        $($(carousel).find('.carousel-indicators, a[class^="carousel-control-"]')).detach(); // eslint-disable-line
    }

    $(carousel).carousel();

    $($(carousel).find('.carousel-indicators')).attr('aria-hidden', true);

    // Handle previews.
    var preview = $productContainer.find('.carousel__previews');

    $(preview).empty();

    if (smallImages.length > 1) {
        $(preview).append(
            '<div class="row"><div class="col"><div class="imageCarousel__images__small">' + // eslint-disable-line
            '<a class="small-carousel-control-prev" href=" #' + carouselId + '" role="button" data-slide="prev">' + // eslint-disable-line
            '<span class="small-carousel-btn"><i class="uit uit-angle-left-b"></i></span>' + // eslint-disable-line
            '<span class="sr-only">' + $(carousel).data('prev') + '</span>' + // eslint-disable-line
            '</a>' + // eslint-disable-line
            (function () { // eslint-disable-line
                var images = '';  // eslint-disable-line

                for (var i = 0; i < smallImages.length; i++) { // eslint-disable-line
                    images += '<a class="imageCarousel__images--small" href=" #' + carouselId + '" role="button" data-slide-to="' + i + '">' + // eslint-disable-line
                        '<img src="' + smallImages[i].url + '" alt="' + smallImages[i].alt + ' image number ' + i + '" itemprop="image" />' + // eslint-disable-line
                        '</a>'; // eslint-disable-line
                } // eslint-disable-line

                return images; // eslint-disable-line
            })() + // eslint-disable-line
            '<a class="small-carousel-control-next" href=" #' + carouselId + '" role="button" data-slide="next">' + // eslint-disable-line
            '<span class="small-carousel-btn"><i class="uit uit-angle-right-b"></i></span>' + // eslint-disable-line
            '<span class="sr-only">' + $(carousel).data('next') + '</span>' +// eslint-disable-line
            '</a>' + // eslint-disable-line
            '</div></div></div>' // eslint-disable-line
        );
    }
}

function updateStepMinQuantityValueAndLabel(response, $productContainer) {
    $productContainer
        .parent()
        .parent()
        .find('[data-product-field="quantity"]')
        .attr('min', response.product.minOrderQuantity);
    $productContainer
        .parent()
        .parent()
        .find('.minQuantityValue')
        .text(parseInt(response.product.minOrderQuantity, 10));
    $productContainer
        .parent()
        .parent()
        .find('[data-product-field="quantity"]')
        .attr('step', response.product.stepOrderQuantity);
    $productContainer
        .parent()
        .parent()
        .find('.stepQuantityValue')
        .text(parseInt(response.product.stepOrderQuantity, 10));

    var currentQuantity = parseInt(
        $productContainer
            .parent()
            .parent()
            .find('[data-product-field="quantity"]')
            .val(),
        10
    );
    var minOrderQuantity = parseInt(
        $productContainer
            .parent()
            .parent()
            .find('[data-product-field="quantity"]')
            .attr('min'),
        10
    );
    var stepQuantity = parseInt(
        $productContainer
            .parent()
            .parent()
            .find('[data-product-field="quantity"]')
            .attr('step'),
        10
    );

    var quantityInfo = setQuantityInfo(
        currentQuantity,
        minOrderQuantity,
        stepQuantity
    );

    var updateBtnDisabled = document.getElementsByClassName(
        'update-cart-product-global'
    );

    if (quantityInfo.QuantityMeetsMinimumAValue) {
        if (
            !$productContainer
                .parent()
                .parent()
                .find('.minQuantityError')
                .hasClass('hidden')
        ) {
            $productContainer
                .parent()
                .parent()
                .find('.minQuantityError')
                .addClass('hidden');
        }
        if (quantityInfo.QuantityMeetsStepValue) {
            if (
                !$productContainer
                    .parent()
                    .parent()
                    .find('.stepQuantityError')
                    .hasClass('hidden')
            ) {
                $productContainer
                    .parent()
                    .parent()
                    .find('.stepQuantityError')
                    .addClass('hidden');
            }
            if (
                updateBtnDisabled !== undefined &&
                updateBtnDisabled.length > 0 &&
                includes(updateBtnDisabled[0].className, 'disabled')
            ) {
                $('.update-cart-product-global').removeClass('disabled');
            }
        } else {
            $productContainer
                .parent()
                .parent()
                .find('.stepQuantityError')
                .removeClass('hidden');
            if (
                updateBtnDisabled !== undefined &&
                updateBtnDisabled.length > 0 &&
                !includes(updateBtnDisabled[0].className, 'disabled')
            ) {
                $('.update-cart-product-global').addClass('disabled');
            }
        }
    } else {
        $productContainer
            .parent()
            .parent()
            .find('.minQuantityError')
            .removeClass('hidden');
        if (
            updateBtnDisabled !== undefined &&
            updateBtnDisabled.length > 0 &&
            !includes(updateBtnDisabled[0].className, 'disabled')
        ) {
            $('.update-cart-product-global').addClass('disabled');
        }

        if (
            !$productContainer
                .parent()
                .parent()
                .find('.stepQuantityError')
                .hasClass('hidden')
        ) {
            $productContainer
                .parent()
                .parent()
                .find('.stepQuantityError')
                .addClass('hidden');
        }
    }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts =
        $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(
            response.product.variationAttributes,
            $productContainer,
            response.resources,
            response.product.baseAttributes.showVariationAttrbutesAsButtons
        );
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer
                .parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer
                .parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }

        //Update Audiobook callout
        $("#availableAsAudiobook").addClass("d-none")
        for (var i = 0; i < response.product.variationAttributes.length; i++) {
            for (var j = 0; j < response.product.variationAttributes[i].values.length; j++) {
                var attribute = response.product.variationAttributes[i].values[j];
                if (attribute.displayValue === 'Audio Book' && !attribute.selected) {
                    $("#availableAsAudiobook").removeClass("d-none");
                }
            }
        }

    }

    // Update primary images
    var primaryImageUrls = response.product.images;
    createCarousel(primaryImageUrls, $productContainer);


    //update product badging
    if (
        response.product.baseAttributes !== undefined &&
        response.product.baseAttributes !== null
    ) {
        var newBadge = response.product.baseAttributes.productBadging;
        var newBadgeDate = response.product.baseAttributes.badgingEndDate;
        var date = new Date();
        var currentDate = date.toISOString();

        if (!newBadge || !newBadgeDate || newBadgeDate < currentDate) {
            $('.productBadgeValue').text("");
            $('.productBadge').addClass('empty');
        } else if (newBadge && newBadgeDate && newBadgeDate >= currentDate) {
            $('.productBadge').removeClass('empty');
            $('.productBadgeValue').text(newBadge);
        }
    }

    // Update pricing, except for tiered pricing on cart edit modal
    var isModal = $productContainer.closest('.modal-content').length > 0;
    var isTiered =
        response.product.price.html.indexOf(
            pricingConstants.PriceTypes.Tiered
        ) > 0;
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        if (!(isModal && isTiered)) {
            $priceSelector.replaceWith(response.product.price.html);
        } else {
            var valueElement = $priceSelector.find('.value');
            if (valueElement !== undefined && valueElement.length > 0) {
                valueElement.addClass('hidden');
            }
        }
    }

    // Update promotions
    $productContainer
        .find('.promotions')
        .empty()
        .html(response.product.promotionsHtml);

    // update Title
    $productContainer
        .find('.product-name')
        .empty()
        .html(response.product.productName);

    // Support new product detail page.
    $productContainer
        .find('.productDetailPage__header__details__title')
        .empty()
        .html(response.product.productName);


    // update short description
    $productContainer
        .find('.productDetailPage__header__details__description')
        .empty()
        .html(response.product.shortDescription);

    // update quantity step and min if not donation products
    if (!includes(response.queryString, 'donationAmount')) {
        updateStepMinQuantityValueAndLabel(response, $productContainer);
    }

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product,
            $productContainer: $productContainer,
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        var quantityInfo = getQuantityValues();

        if (quantityInfo.QuantityMeetsMinimumAndStepValues) {
            $(
                'button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global'
            )
                .trigger('product:updateAddToCart', {
                    product: response.product,
                    $productContainer: $productContainer,
                })
                .trigger('product:statusUpdate', response.product);
        } else {
            $('.add-to-cart').attr('disabled', true);
        }
    }

    // Update attributes
    $productContainer
        .find('.main-attributes')
        .empty()
        .html(getAttributesHtml(response.product.attributes));
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if (!($productContainer.parent('.bonus-product-item').length > 0)) {
        var optionsHtml = quantities
            .map(function (quantity) {
                var selected = quantity.selected ? ' selected ' : '';
                return (
                    '<option value="' +
                    quantity.value +
                    '"  data-url="' +
                    quantity.url +
                    '"' +
                    selected +
                    '>' +
                    quantity.value +
                    '</option>'
                );
            })
            .join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect', {
            url: selectedValueUrl,
            container: $productContainer,
        });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer);
                updateOptions(data.product.optionsHtml, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                $('body').trigger('product:afterAttributeSelect', {
                    data: data,
                    container: $productContainer,
                });
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            },
        });
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString =
        '<!-- Modal -->' +
        '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog choose-bonus-product-dialog" ' +
        'data-total-qty="' +
        data.maxBonusItems +
        '"' +
        'data-UUID="' +
        data.uuid +
        '"' +
        'data-pliUUID="' +
        data.pliUUID +
        '"' +
        'data-addToCartUrl="' +
        data.addToCartUrl +
        '"' +
        'data-pageStart="0"' +
        'data-pageSize="' +
        data.pageSize +
        '"' +
        'data-moreURL="' +
        data.showProductsUrlRuleBased +
        '"' +
        'data-bonusChoiceRuleBased="' +
        data.bonusChoiceRuleBased +
        '">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '    <span class="">' +
        data.labels.selectprods +
        '</span>' +
        '    <button type="button" class="close pull-right" data-dismiss="modal">' +
        '        <span aria-hidden="true">&times;</span>' +
        '        <span class="sr-only"> </span>' +
        '    </button>' +
        '</div>' +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(
                response.enterDialogMessage
            );
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(
                response.closeButtonText
            );
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        },
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (
        response.newBonusDiscountLineItem &&
        Object.keys(response.newBonusDiscountLineItem).length !== 0
    ) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append('<div class="add-to-cart-messages"></div>');
        }

        $('.add-to-cart-messages').append(
            '<div class="alert ' +
            messageType +
            ' add-to-basket-alert text-center" role="alert">' +
            response.message +
            '</div>'
        );

        setTimeout(function () {
            $('.add-to-basket-alert').remove();
        }, 5000);
    }
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt(
                $(this).find('label.quantity').data('quantity'),
                10
            ),
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption
                .find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId,
            };
        })
        .toArray();

    return JSON.stringify(options);
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            },
        });
    }
}

/**
 * Checks quantity input to see if it meets the minimum value and step requirements.
 *
 * @return {object} json object of boolean values for whether the the quantity meets the minimum value, meets the step requirements, and meets both
 */
function getQuantityValues() {
    var currentQuantity = parseInt(
        $('[data-product-field="quantity"]').val(),
        10
    );

    if (isNaN(currentQuantity) || currentQuantity < 1) {
        $('.add-to-cart').attr('disabled', true);

    }

    return getQuantityInfo(currentQuantity);
}

/**
 * Checks quantity input to see if it meets the minimum value and step requirements.
 *
 * @return {object} json object of boolean values for whether the the quantity meets the minimum value, meets the step requirements, and meets both
 */
function getQuantityInfo(currentQuantity) {
    var minOrderQuantity = parseInt(
        $('[data-product-field="quantity"]').attr('min'),
        10
    );
    var stepQuantity = parseInt(
        $('[data-product-field="quantity"]').attr('step'),
        10
    );

    var quantityInfo = setQuantityInfo(
        currentQuantity,
        minOrderQuantity,
        stepQuantity
    );
    return quantityInfo;
}

function setQuantityInfo(currentQuantity, minOrderQuantity, stepQuantity) {
    return {
        QuantityMeetsMinimumAValue: currentQuantity >= minOrderQuantity,
        QuantityMeetsStepValue: currentQuantity % stepQuantity === 0,
        QuantityMeetsMinimumAndStepValues:
            currentQuantity >= minOrderQuantity &&
            currentQuantity % stepQuantity === 0,
    };
}

module.exports = {

    attributeSelect: attributeSelect,
    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        },
    },

    focusChooseBonusProductModal: function () {
        $('body').on('shown.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal')
                .siblings()
                .attr('aria-hidden', 'true');
            $('#chooseBonusProductModal .close').focus();
        });
    },

    onClosingChooseBonusProductModal: function () {
        $('body').on(
            'hidden.bs.modal',
            '#chooseBonusProductModal',
            function () {
                $('#chooseBonusProductModal')
                    .siblings()
                    .attr('aria-hidden', 'false');
            }
        );
    },

    trapChooseBonusProductModalFocus: function () {
        $('body').on('keydown', '#chooseBonusProductModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#chooseBonusProductModal',
                firstElementSelector: '.close',
                lastElementSelector: '.add-bonus-products',
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    colorAttribute: function () {
        $(document).on('click', '[data-attr="color"] button', function (e) {
            e.preventDefault();

            if ($(this).attr('disabled')) {
                return;
            }
            $(".color-attribute").removeClass('disabled')
            $(this).addClass('disabled')
            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }

            attributeSelect($(this).attr('data-url'), $productContainer);
        });
    },

    selectAttribute: function () {
        $(document).on(
            'change',
            'select[class*="select-"], .options-select',
            function (e) {
                e.preventDefault();

                var $productContainer = $(this).closest('.set-item');
                if (!$productContainer.length) {
                    $productContainer = $(this).closest('.product-detail');
                }
                attributeSelect(e.currentTarget.value, $productContainer);
            }
        );
    },

    availability: function () {
        var update = function (e) {
            e.preventDefault();
            var $productContainer = $('.productDetailPage__quantity__input')
                .closest('.product-detail');

            if (!$productContainer.length) {
                $productContainer = $('.productDetailPage__quantity__input')
                    .closest('.modal-content')
                    .find('.product-quickview');
            }

            if ($('.bundle-items', $productContainer).length === 0) {
                var quantityInfo = getQuantityValues();

                if (quantityInfo.QuantityMeetsMinimumAValue) {
                    var minQuantityErrorElement =
                        document.getElementsByClassName('minQuantityError');
                    if (
                        minQuantityErrorElement !== undefined &&
                        minQuantityErrorElement.length > 0 &&
                        !includes(minQuantityErrorElement[0].className, 'hidden')
                    ) {
                        $('.minQuantityError').addClass('hidden');
                    }
                    if (quantityInfo.QuantityMeetsStepValue) {
                        var stepQuantityErrorElement =
                            document.getElementsByClassName(
                                'stepQuantityError'
                            );
                        if (
                            stepQuantityErrorElement !== undefined &&
                            stepQuantityErrorElement.length > 0 &&
                            !includes(stepQuantityErrorElement[0].className, 'hidden')
                        ) {
                            $('.stepQuantityError').addClass('hidden');
                        }

                        var url = $('.initial-quantity-url').val();

                        var option = $('.productDetailPage__quantity__input').find('option').data('url');

                        if (option) {
                            url = option;
                        }

                        url = url.split('=');

                        url[url.length - 1] = 1;

                        url = url.join('=');

                        attributeSelect(url, $productContainer);
                    } else {
                        $('.stepQuantityError').removeClass('hidden');
                    }
                } else {
                    $('.minQuantityError').removeClass('hidden');
                }
            }
        };

        $(document).on(
            'keyup',
            '.productDetailPage__quantity__input',
            function (e) {
                update(e);
            }
        );

        $(".productDetailPage__quantity__increase, .productDetailPage__quantity__reduce").click(function (e) {
            update(e);
        });
    },

    addToCart: function () {
        $(document).on(
            'click',
            'button.add-to-cart, button.add-to-cart-global',
            function () {
                var addToCartUrl;
                var pid;
                var pidsObj;
                var setPids;

                $('body').trigger('product:beforeAddToCart', this);

                if (
                    $('.set-items').length &&
                    $(this).hasClass('add-to-cart-global')
                ) {
                    setPids = [];

                    $('.product-detail').each(function () {
                        if (!$(this).hasClass('product-set-detail')) {
                            setPids.push({
                                pid: $(this).find('.product-id').text(),
                                qty: $(this)
                                    .find('[data-product-field="quantity"]')
                                    .val(),
                                options: getOptions($(this)),
                            });
                        }
                    });
                    pidsObj = JSON.stringify(setPids);
                }

                pid = getPidValue($(this));

                var $productContainer = $(this).closest('.product-detail');
                if (!$productContainer.length) {
                    $productContainer = $(this)
                        .closest('.quick-view-dialog')
                        .find('.product-detail');
                }

                addToCartUrl = getAddToCartUrl();

                var form = {
                    pid: pid,
                    pidsObj: pidsObj,
                    childProducts: getChildProducts(),
                    quantity: getQuantitySelected($(this)),
                };

                if (!$('.bundle-item').length) {
                    form.options = getOptions($productContainer);
                }

                $(this).trigger('updateAddToCartFormData', form);
                if (addToCartUrl) {
                    $.ajax({
                        url: addToCartUrl,
                        method: 'POST',
                        data: form,
                        success: function (data) {
                            if (data.success && data.message) {
                                $.spinner().stop();
                                if ($('.add-to-cart-messages').length === 0) {
                                    $('body').append(
                                        '<div class="add-to-cart-messages"></div>'
                                    );
                                }
                                $('.add-to-cart-messages').append(
                                    '<div class="alert alert-danger add-to-basket-alert text-center" role="alert">' +
                                    data.message +
                                    '</div>'
                                );
                                setTimeout(function () {
                                    $('.add-to-basket-alert').remove();
                                }, 3000);

                                //Send to Einstein
                                // Safety check to ensure the Einstein array is available
                                window._etmc = window._etmc || [];

                                var einsteinProducts = [];

                                // Check if the cart has items in the response
                                if (data && data.order && data.order.items && data.order.items.items && data.order.items.items.length > 0) {

                                    // Loop through the JSON array returned by the AJAX call
                                    var items = data.order.items.items;
                                    for (var i = 0; i < items.length; i++) {
                                        einsteinProducts.push({
                                            "item": items[i].id,
                                            "quantity": items[i].quantity ? items[i].quantity : items[i].quantityOptions ? items[i].quantityOptions.minOrderQuantity : 1, 
                                            "price": items[i].price.sales.value,
                                            "unique_id": items[i].id 
                                        });
                                    }

                                    // Fire the event with the fully rebuilt cart
                                    window._etmc.push(["trackCart", { "cart": einsteinProducts }]);

                                } else {
                                    // If the array is empty (user removed the last item)
                                    window._etmc.push(["trackCart", { "clear_cart": true }]);
                                }
                            } else {
                                handlePostCartAdd(data);
                                $('body').trigger('product:afterAddToCart', data);
                                $.spinner().stop();
                                miniCartReportingUrl(data.reportingURL);

                                var products = [];

                                data.cart.items.forEach(function (item) {
                                    products.push({
                                        name: item.gtmData.name,
                                        id: item.gtmData.id,
                                        price: item.gtmData.price,
                                        brand: item.itemType.value
                                            ? item.itemType.value
                                            : 'item',
                                        category: item.gtmData.category,
                                        variant: item.gtmData.mediaType,
                                        quantity: item.quantity,
                                    });
                                });

                                dataLayerHandler.pushToDataLayerWithClient({
                                    event: 'addToCart',
                                    ecommerce: {
                                        currencyCode: 'USD', // TODO: DL do not hardcode this.
                                        add: {
                                            products: products,
                                        },
                                    },
                                });
                            }
                        },
                        error: function () {
                            $.spinner().stop();
                        },
                    });
                }
            }
        );
    },
    selectBonusProduct: function () {
        $(document).on('click', '.select-bonus-product', function () {
            var $choiceOfBonusProduct = $(this).parents(
                '.choice-of-bonus-product'
            );
            var pid = $(this).data('pid');
            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            var submittedQty = parseInt(
                $choiceOfBonusProduct.find('.bonus-quantity-select').val(),
                10
            );
            var totalQty = 0;
            $.each(
                $(
                    '#chooseBonusProductModal .selected-bonus-products .selected-pid'
                ),
                function () {
                    totalQty += $(this).data('qty');
                }
            );
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct
                .find('.product-option')
                .data('option-id');
            var valueId = $choiceOfBonusProduct
                .find('.options-select option:selected')
                .data('valueId');
            if (totalQty <= maxPids) {
                var selectedBonusProductHtml =
                    '' +
                    '<div class="selected-pid row" ' +
                    'data-pid="' +
                    pid +
                    '"' +
                    'data-qty="' +
                    submittedQty +
                    '"' +
                    'data-optionID="' +
                    (optionID || '') +
                    '"' +
                    'data-option-selected-value="' +
                    (valueId || '') +
                    '"' +
                    '>' +
                    '<div class="col-sm-11 col-9 bonus-product-name" >' +
                    $choiceOfBonusProduct.find('.product-name').html() +
                    '</div>' +
                    '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>' +
                    '</div>';
                $('#chooseBonusProductModal .selected-bonus-products').append(
                    selectedBonusProductHtml
                );
                $('.pre-cart-products').html(totalQty);
                $('.selected-bonus-products .bonus-summary').removeClass(
                    'alert-danger'
                );
            } else {
                $('.selected-bonus-products .bonus-summary').addClass(
                    'alert-danger'
                );
            }
        });
    },
    removeBonusProduct: function () {
        $(document).on('click', '.selected-pid', function () {
            $(this).remove();
            var $selected = $(
                '#chooseBonusProductModal .selected-bonus-products .selected-pid'
            );
            var count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data('qty'), 10);
                });
            }

            $('.pre-cart-products').html(count);
            $('.selected-bonus-products .bonus-summary').removeClass(
                'alert-danger'
            );
        });
    },
    enableBonusProductSelection: function () {
        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
            $('button.select-bonus-product', response.$productContainer).attr(
                'disabled',
                !response.product.readyToOrder || !response.product.available
            );
            var pid = response.product.id;
            $('button.select-bonus-product', response.$productContainer).data(
                'pid',
                pid
            );
        });
    },
    showMoreBonusProducts: function () {
        $(document).on('click', '.show-more-bonus-products', function () {
            var url = $(this).data('url');
            $('.modal-content').spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (html) {
                    var parsedHtml = parseHtml(html);
                    $('.modal-body').append(parsedHtml.body);
                    $('.show-more-bonus-products:first').remove();
                    $('.modal-content').spinner().stop();
                },
                error: function () {
                    $('.modal-content').spinner().stop();
                },
            });
        });
    },
    addBonusProductsToCart: function () {
        $(document).on('click', '.add-bonus-products', function () {
            var $readyToOrderBonusProducts = $(
                '.choose-bonus-product-dialog .selected-pid'
            );
            var queryString = '?pids=';
            var url = $('.choose-bonus-product-dialog').data('addtocarturl');
            var pidsObject = {
                bonusProducts: [],
            };

            $.each($readyToOrderBonusProducts, function () {
                var qtyOption = parseInt($(this).data('qty'), 10);

                var option = null;
                if (qtyOption > 0) {
                    if (
                        $(this).data('optionid') &&
                        $(this).data('option-selected-value')
                    ) {
                        option = {};
                        option.optionId = $(this).data('optionid');
                        option.productId = $(this).data('pid');
                        option.selectedValueId = $(this).data(
                            'option-selected-value'
                        );
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data('pid'),
                        qty: qtyOption,
                        options: [option],
                    });
                    pidsObject.totalQty = parseInt(
                        $('.pre-cart-products').html(),
                        10
                    );
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString =
                queryString +
                '&uuid=' +
                $('.choose-bonus-product-dialog').data('uuid');
            queryString =
                queryString +
                '&pliuuid=' +
                $('.choose-bonus-product-dialog').data('pliuuid');
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $('#chooseBonusProductModal').modal('hide');
                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append(
                                '<div class="add-to-cart-messages"></div>'
                            );
                        }
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-danger add-to-basket-alert text-center"' +
                            ' role="alert">' +
                            data.errorMessage +
                            '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                        }, 3000);
                    } else {
                        $('.configure-bonus-product-attributes').html(data);
                        $('.bonus-products-step2').removeClass(
                            'hidden-xl-down'
                        );
                        $('#chooseBonusProductModal').modal('hide');

                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append(
                                '<div class="add-to-cart-messages"></div>'
                            );
                        }
                        $('.minicart-quantity').html(data.totalQty);
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-success add-to-basket-alert text-center"' +
                            ' role="alert">' +
                            data.msgSuccess +
                            '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                            if ($('.cart-page').length) {
                                location.reload();
                            }
                        }, 1500);
                    }
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    },

    getPidValue: getPidValue,
    getQuantitySelected: getQuantitySelected,
    miniCartReportingUrl: miniCartReportingUrl,
    getQuantityValues: getQuantityValues,
    getQuantityInfo: getQuantityInfo,
};
